<template>
  <div class="sf-page">
    <top-header v-bind:subtitle="$t('subtitle')"
                v-bind:title="$t('suppliers')" />
    <div class="sf-container">
      <sticky-bar class="sf-suppliers__toolbar">
        <v-card class="sf-card"
                flat>
          <div class="sf-toolbar__row">
            <v-text-field class="sf-search sf-toolbar__search"
                          clearable
                          dense
                          flat
                          hide-details
                          prepend-inner-icon="ti-search"
                          solo
                          v-bind:placeholder="$t('search')"
                          v-model="search" />
            <span class="sf-toolbar__hint hidden-xs-only"
                  v-if="!loading">
              {{ $tc('supplierCount', filteredSuppliers.length, { count: filteredSuppliers.length }) }}
            </span>
          </div>
        </v-card>
      </sticky-bar>

      <supplier-presentation-list class="sf-suppliers__list"
                                  v-bind:loading="loading"
                                  v-bind:suppliers="filteredSuppliers"
                                  v-bind:lastSupplierId="lastSupplierId" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import TopHeader from '@/components/common/TopHeader'
  import SupplierPresentationList from '@/components/SupplierPresentationList'
  import StickyBar from '@/components/common/StickyBar'

  export default {
    components: {
      StickyBar,
      SupplierPresentationList,
      TopHeader
    },
    async created() {
      this.loading = true
      await this.$store.dispatch('loadSuppliersForMe')
      this.$store.dispatch('loadProductsForMe') // Load in background, since it is only used for searching
      this.loading = false

      if (this.$route.query.lastSupplierId != null) {
        this.lastSupplierId = this.$route.query.lastSupplierId
      }
    },
    computed: {
      filteredSuppliers() {
        let suppliers = this.suppliers

        if (this.search != null && this.search.trim().length !== 0) {
          const search = this.search.trim().toLowerCase()

          let productSuppliers = this.products.filter(p => `${p.id} ${p.title}`.toLowerCase().includes(search)).map(p => p.supplierId)

          // Firmenname, Anzeigename, Standnummer oder Artikel
          suppliers = suppliers.filter(s => `${s.companyName || ''} ${s.supplierGroup || ''} ${s.boothNumber || ''}`.toLowerCase().includes(search) || productSuppliers.includes(s.id))
        }

        return suppliers
      },
      suppliers() {
        return this.suppliersForOrderType(null).filter(s => s.productCount > 0)
      },
      ...mapGetters([
        'products',
        'suppliersForOrderType'
      ])
    },
    data: () => ({
      loading: false,
      lastSupplierId: null,
      search: null
    }),
    name: 'SuppliersList',
    watch: {
      lastSupplierId() {
        let element = document.getElementById(this.lastSupplierId)
        if (element != null) {
          this.$vuetify.goTo(element, { duration: 0, offset: 160 })
        }
      }
    }
  }
</script>

<i18n>
  {
    "de": {
      "suppliers": "Lieferanten",
      "search": "Lieferant, Standnummer oder Artikel suchen",
      "subtitle": "Alle Lieferanten mit Ordersatz – farbige Kennzeichen zeigen, für welche Bestellwoche Sie bereits bestellt haben.",
      "supplierCount": "{count} Lieferanten | {count} Lieferant | {count} Lieferanten"
    },
    "en": {
      "suppliers": "Suppliers",
      "search": "Search supplier, booth number or product",
      "subtitle": "All suppliers with an order sheet – coloured tags show the order weeks you already ordered for.",
      "supplierCount": "{count} suppliers | {count} supplier | {count} suppliers"
    }
  }
</i18n>

<style scoped>
  .sf-suppliers__toolbar {
    margin-bottom: 24px;
  }
</style>
